import { render, staticRenderFns } from "./loader.vue?vue&type=template&id=15dcfade&scoped=true&lang=pug&"
import script from "./loader.vue?vue&type=script&lang=ts&"
export * from "./loader.vue?vue&type=script&lang=ts&"
import style0 from "./loader.vue?vue&type=style&index=0&id=15dcfade&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dcfade",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
